import { ControlType, Property, PropertyType } from "../../../base/types";

import { DesignerMode } from "../../types";
import { FC } from "react";
import { IControlAttributes } from "../../../base/models";
import { QRCodeCanvas } from "qrcode.react";
import { Registry } from "../../../base/register";
import { useGetProperties } from "../../../base/hooks";

export const QRCodeComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { properties } = useGetProperties({ bindings: control.bindings });
    const value: string | undefined = properties[Property.Value];
    const size: number | undefined = properties[Property.Size];

    if (designerMode === DesignerMode.Draft && !value) {
        return <div>
            <div className="alert alert-info fs-8 mb-0">
                <div className="badge badge-info mb-2">QR Code Component</div>
            </div>
        </div>
    }

    return (
        <QRCodeCanvas className={className} value={value || ""} size={size || 300} />
    )
}

Registry.addControl({
    id: "f9bb2d33-e610-4c0b-937b-4bb13259fc23",
    name: "QR Code",
    type: ControlType.QRCode,
    properties: [
        { id: Property.Value, name: 'Value', type: PropertyType.String },
        { id: Property.Size, name: 'Size', type: PropertyType.Number },
    ],
    component: QRCodeComponent
})
